import React from 'react';
import { Box, Typography } from '@mui/material';
import { Helmet } from 'react-helmet';

const Demo = () => {
    return (
        <>
            <Helmet>
                <title>Demo - HawkClient</title>
                <meta
                    name="description"
                    content="View the demo for HawkClient, a developer-friendly offline-only API client."
                />
            </Helmet>
            <Box sx={{ p: 3, minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                <Typography variant="h4" gutterBottom>
                    Demo Video
                </Typography>
                <Typography variant="body1" gutterBottom>
                    Watch the demo of HawkClient below:
                </Typography>
                <Box
                    component="iframe"
                    src="https://www.youtube.com/embed/fu8xDSnUoIU"
                    sx={{
                        width: '100%',
                        maxWidth: '800px',
                        height: '450px',
                        border: 'none',
                        borderRadius: '8px',
                        boxShadow: 3,
                    }}
                    title="HawkClient Demo Video"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                />
                <Typography variant="body1" gutterBottom>
                    API flows Demo
                </Typography>
                <Box
                    component="iframe"
                    src="https://www.youtube.com/embed/9IqkVy_3iXc"
                    sx={{
                        width: '100%',
                        maxWidth: '800px',
                        height: '450px',
                        border: 'none',
                        borderRadius: '8px',
                        boxShadow: 3,
                    }}
                    title="HawkClient Demo Video"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                />
            </Box>
        </>
    );
};

export default Demo;
